import { useEffect, useState } from "react";
import { toast } from "sonner";

import { AdminShell } from "@/components/admin/admin-shell";
import { Badge } from "@/components/ui/badge";
import { apiGet, apiPatch } from "@/services/api";
import { formatPrice } from "@/lib/utils";

type Withdrawal = {
  id: string;
  amount: number;
  status: string;
  method: string | null;
  note: string | null;
  adminNote: string | null;
  createdAt: string;
  vendor: { businessName: string; slug: string } | null;
};

export function AdminVendorWithdrawalsPage() {
  const [withdrawals, setWithdrawals] = useState<Withdrawal[]>([]);

  async function load() {
    const d = await apiGet<{ withdrawals: Withdrawal[] }>("/api/admin/vendor-withdrawals");
    setWithdrawals(d?.withdrawals ?? []);
  }
  useEffect(() => {
    void load();
  }, []);

  async function act(id: string, action: string) {
    try {
      await apiPatch(`/api/admin/vendor-withdrawals/${id}/${action}`, {});
      toast.success("Updated");
      void load();
    } catch {
      toast.error("Action failed");
    }
  }

  return (
    <AdminShell title="Withdrawals" subtitle="Vendor payout requests">
      <div className="amazon-card divide-y divide-slate-100 dark:divide-white/10">
        {withdrawals.length === 0 && <p className="p-6 text-sm text-slate-500">No withdrawal requests.</p>}
        {withdrawals.map((w) => (
          <div key={w.id} className="flex flex-wrap items-center justify-between gap-2 p-4">
            <div>
              <p className="font-bold">
                {formatPrice(w.amount)} · {w.vendor?.businessName ?? "Vendor"}
              </p>
              <p className="text-xs text-slate-500">
                {w.method ?? "—"} · {new Date(w.createdAt).toLocaleDateString()} · {w.note ?? ""}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Badge
                tone={
                  w.status === "COMPLETED" ? "success" : w.status === "REJECTED" || w.status === "FAILED" ? "deal" : "prime"
                }
              >
                {w.status}
              </Badge>
              {w.status === "PENDING" && (
                <>
                  <button className="text-xs font-bold text-emerald-600" onClick={() => act(w.id, "approve")}>Approve</button>
                  <button className="text-xs font-bold text-red-600" onClick={() => act(w.id, "reject")}>Reject</button>
                </>
              )}
              {w.status === "APPROVED" && (
                <button className="text-xs font-bold text-emerald-600" onClick={() => act(w.id, "complete")}>Mark paid</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </AdminShell>
  );
}
